export default {
  login: "/admin",
}
